export default {
  Integrations: {
    header: {
      add_integration: 'Adicionar integração',
      integrations: 'Integrações',
    },
    list: {
      integration: 'Integração',
      status: 'Status',
    },
    list_item: {
      details: 'Detalhes',
      fieldview: 'Fieldview',
      google_calendar: 'Google Calendar',
      leaf_agriculture: 'NDVI',
      active: 'Ativo',
      inactive: 'Inativo',
      disabled_active_integration:
        'Integração não pode ser desabilitada manualmente por enquanto. Entre em contato com Suporte.',
      disabled_inactive_integration:
        'Integração não pode ser habilitada manualmente por enquanto. Entre em contato com Suporte.',
    },
    add_modal: {
      title: 'Adicione uma integração',
      action: 'Adicionar',
      description:
        'Para fazer a integração, selecione esta opção e adicione, junto com outras integrações desejadas',
      google_calendar_warning_info:
        'As aplicações de semeaduras de todas suas contas e fazendas que forem criadas aparecerão no calendário da sua conta Google, não importa por onde acesse.',
      successful_authorization:
        'Autorização para o Google Calendar com sucesso.',
      integrations_added: 'As integrações foram adicionadas com sucesso',
    },
    google_calendar_details: {
      title: 'Conecte sua conta com o Google Calendar',
      infos:
        'Com esse integração, o seu usuário ficará associado ao Google Calendar. Caso deseje que a Digifarmz pare de notificá-lo sobre suas aplicações, basta inativar a integração quando quiser',
    },
    fieldview_details: {
      title: 'Conecte sua conta com a Climate FieldView',
      infos:
        'Com esse integração, iremos trazer as seguintes informações para você',
      fields: 'Talhões',
      farms: 'Fazendas',
    },
    leaf_agriculture_details: {
      title: 'Conecte suas fazendas com o NDVI',
      infos:
        'O NDVI (Normalized Difference Vegetation Index) é uma ferramenta de monitoramento agrícola, ambiental ou de cobertura vegetal. Ela auxilia a identificar a saúde da sua plantação através de imagens de satélite, que serão exibidas para suas fazendas e talhões',
    },
    empty_state_details: {
      title: 'Selecione uma ou mais integrações',
      text: 'Controle quais integrações você deseja possuir para seu usuário/conta',
    },
    integration_details_modal: {
      fieldview: 'Detalhes da integração Fieldview',
      google_calendar: 'Detalhes da integração Google Calendar',
      leaf_agriculture: 'Detalhes da integração NDVI',
    },
  },
}
